"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPageReleaseLayouts = void 0;
exports.SetPageReleaseLayouts = ['cropped', 'full_width'];
//# sourceMappingURL=PreSaveRelease.js.map